import { styled, css } from 'styled-components';
import { theme } from '../../../../constants/theme.mjs';
import '../../../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const Wrap = styled.div`
  position: relative;
`;
const TopologyHeader = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: ${theme.fontFamily.default};
  gap: 8px;
  line-height: 20px;
  outline: none;
  padding: 0;
  margin: 0 0 16px;
  width: fit-content;
`;
const SectionTitle = styled.h5`
  color: #212327;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  margin: 0;
`;
const StyledArrowIcon = styled(StyleableSvgImage)`
  color: #212427;
  transition: transform 0.35s linear;

  ${({
  $isOpen
}) => $isOpen && css`
      transform: rotate(180deg);
    `}
`;
const MainCards = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  margin-bottom: 10px;
  position: relative;
  z-index: 2;
`;
const ChildCards = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition:
    max-height 0.35s cubic-bezier(0.4, 0, 0.6, 1),
    opacity 0.4s ease-in-out;

  ${({
  $isVisible
}) => $isVisible && css`
      max-height: 100vh;
      opacity: 1;
      overflow: unset;
    `}
`;
const MainCard = styled.a`
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: ${theme.fontFamily.default};
  gap: 4px;
  min-height: 78px;
  padding: 12px 20px;
  position: relative;

  ::before {
    background: linear-gradient(
      96.1deg,
      ${theme.colors.dodgerblue} 0.54%,
      #6bd2fd 100%
    );
    border-radius: 6px;
    content: "";
    inset: 0;
    position: absolute;
    z-index: -2;
  }

  ::after {
    background-color: #fff;
    border-radius: 4px;
    content: "";
    inset: 2px;
    position: absolute;
    transition: background-color 0.2s ease-in-out;
    z-index: -1;
  }

  :hover {
    ::after {
      background-color: rgb(255 255 255 / 0.8);
    }
  }

  ${({
  $isActive
}) => $isActive && `
      ::after {
        background-color: rgb(255 255 255 / 0.8);
      }
  `}
`;
const CardIcon = styled.img`
  flex-shrink: 0;
  height: ${({
  $height
}) => $height}px;
  width: ${({
  $width
}) => $width}px;
  object-fit: contain;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 9px;
  padding-bottom: 8px;
  position: relative;
  z-index: 0;
`;
const ChildTreeBranch = styled.svg`
  left: 0;
  opacity: ${({
  $height
}) => $height ? 1 : 0};
  position: absolute;
  top: -20px;
  transition: opacity 0.2s ease-in-out;
  z-index: -1;
`;
const ChildCard = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: ${theme.fontFamily.default};
  min-height: 108px;
  outline: none;
  padding: 10px;
  position: relative;

  ::before {
    background: linear-gradient(90deg, #e7e7e7 0%, #f7f7f7 59%);
    border-radius: 6px;
    content: "";
    inset: 0;
    position: absolute;
    z-index: -2;
  }

  ::after {
    background-color: #fff;
    border-radius: 4px;
    content: "";
    inset: 1px;
    position: absolute;
    transition: background-color 0.2s ease-in-out;
    z-index: -1;
  }

  &:hover {
    ${CardIcon} {
      filter: invert(29%) sepia(84%) saturate(3534%) hue-rotate(206deg)
        brightness(102%) contrast(108%);
    }

    ::before {
      background: linear-gradient(90deg, #338cff 0%, #fff 59%);
    }

    ::after {
      background: rgb(255 255 255 / 0.8);
      inset: 2px;
    }
  }
`;
const ChildChildCard = styled(ChildCard)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: max-content;
  left: 10px;
  min-height: 42px;
  padding: 4px 8px;
  width: calc(100% - 10px);

  ${CardIcon} {
    width: 32px;
    height: 32px;
  }
`;
const Content = styled.div`
  position: relative;
  z-index: 3;
`;
const CardLabel = styled.p`
  color: #212327;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  margin: 0;
  text-align: left;
`;
const CardDescription = styled.p`
  color: #676f79;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
  text-align: left;

  br {
    display: none;
  }
`;
export { CardDescription, CardIcon, CardLabel, ChildCard, ChildCards, ChildChildCard, ChildTreeBranch, Column, Content, MainCard, MainCards, SectionTitle, StyledArrowIcon, TopologyHeader, Wrap };
//# sourceMappingURL=SiteMapColumns.styles.mjs.map
